import React from 'react';
import './StatusBadge.css';

/**
 * StatusBadge - Opera Cloud status indicator component
 * @param {string} code - 2-letter status code (DS, EX, ME, RI, DE, IV, ID, CT)
 * @param {string} tooltip - Optional tooltip text
 */
const StatusBadge = ({ code, tooltip }) => {
  const codeUpper = code.toUpperCase();
  const badgeClass = `status-badge badge-${code.toLowerCase()}`;
  
  // Map display text for specific codes to mixed case
  const displayText = {
    'DS': 'Ds',
    'EX': 'Ex',
    'ME': 'Me',
    'DE': 'De'
  }[codeUpper] || codeUpper;
  
  return (
    <span 
      className={badgeClass}
      title={tooltip}
      aria-label={tooltip || code}
    >
      {displayText}
    </span>
  );
};

export default StatusBadge;
